import { IonAlert, IonButton, IonIcon, IonLabel } from '@ionic/react';
import { cardOutline } from 'ionicons/icons';
import React from 'react';
import { connect } from 'react-redux';
import { NormalText, Spacer, StrongText, Title } from '../../components/common';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import { withTranslation } from '../../lib/translate';
import { forwardTo, goBack, isDefined } from '../../lib/utils';
import { removePaymentCard, updateProfile } from '../../store/actions';
import CardList from '../../components/cardList';
import './index.css';
import { ReactComponent as CardDefault } from '../../assets/images/card-default.svg';

class Cards extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			removeCardAlert: null,
			selectPaymentCard: this.props.profile.cardToken || null,
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.profile.cardToken !== this.props.profile.cardToken) {
			this.setState({ selectPaymentCard: this.props.profile.cardToken });
		}
	}

	changeDefaultPaymentCard = (event) =>
		this.setState({ selectPaymentCard: event.detail.value }, () => {
			this.props.dispatch(updateProfile({ cardToken: event.detail.value }, true));
		});

	removePaymentCard = () => {
		const { __ } = this.props;
		this.props.dispatch(
			removePaymentCard(this.state.removeCardAlert, {
				__,
				cb: () => this.setState({ removeCardAlert: null }),
			}),
		);
	};

	handleRemoveCardAlert = (cardId) => this.setState({ removeCardAlert: cardId });
	backHandler = () => {
		if (this.props.location?.state?.addCardFromAccount) {
			forwardTo('/account')
		} else {
			goBack()
		}
	}
	render() {
		const { __, cards } = this.props;
		const { removeCardAlert } = this.state;
		return (
			<Loading transparent>
				<Layout backHandler={this.backHandler} color="transparent" title={__('Your payment cards')} headerWithTitle={true}>
					<div className="flex-row-wrapper absolute-content box-with-shadow scrollable-y">
							<Title className="web-only page-title-centered">{__('Your payment cards')}</Title>

							{cards.length > 0 ? (
								<CardList />
							) : (
								<div className="cards-list-card box-content no-cards-box">
									<div className="card-icon-wrapper">
										<CardDefault />

									</div>

									<IonLabel className="ion-text-wrap">
										<NormalText className='label-color'>{__('No payment cards added')}</NormalText>
									</IonLabel>
								</div>
							)}
							<Spacer size={5} />
							<IonButton
								expand="block"
								color={`primary`}
								className='button-uppercase'
								onClick={() =>
									forwardTo('/card-add', {
										...(this.props.location && this.props.location.state ? this.props.location.state : {}),
									})
								}
							>
								{ __('Add payment card')}
							</IonButton>
						</div>
				</Layout>
				<IonAlert
					isOpen={isDefined(removeCardAlert)}
					onDidDismiss={() => this.handleRemoveCardAlert(null)}
					message={__('Do you want to remove this card?')}
					buttons={[
						{
							text: __('Cancel'),
							role: 'cancel',
							cssClass: 'secondary link',
						},
						{
							text: __('Remove'),
							handler: () => this.removePaymentCard(),
							cssClass: 'primary'
						},


					]}
				/>
			</Loading>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		cards: store.orders.cards || [],
		profile: store.profile.profile || {},
	};
};

export default connect(mapStateToProps)(withTranslation(Cards));
